'use client';

import { useEffect, useMemo, useState } from 'react';
import { FundWithDetailsEntity } from '../lib/MayzSmartDB';
import { useTokensStoreGeneral } from './useTokensStoreGeneral';

interface TokensStoreForFundsProps {
    mode: 'FundDetails' | 'FundList';
    name?: string;
    fund?: FundWithDetailsEntity;
    isLoadedDetails?: boolean;
    funds?: FundWithDetailsEntity[];
    isLoadedList?: boolean;
    followUp?: boolean;
    addTokenFT?: boolean;
    addSubTokensFT?: boolean;
    swAddPrice?: boolean;
    swAddMetadata?: boolean;
    keepAlive?: boolean;
    initPriceUpdater?: boolean; // si esta verdadero, se hace follow Up actomaticamente
}

export const useTokensStoreForFunds = (props: TokensStoreForFundsProps) => {
    //--------------------------------------
    const { mode, isLoadedDetails, isLoadedList, followUp, keepAlive, addTokenFT, addSubTokensFT, swAddPrice, swAddMetadata, initPriceUpdater } = props;
    //--------------------------------------
    const [random, setRandom] = useState((Math.random() * 100).toString());
    //--------------------------------------
    const name = (props.name === undefined ? (mode === 'FundDetails' ? 'FundDetails' : 'FundList') : props.name) + random;
    //--------------------------------------
    const [fund, setFund] = useState<FundWithDetailsEntity | undefined>(props.fund);
    const [funds, setFunds] = useState<FundWithDetailsEntity[]>(props.funds ?? []);
    //--------------------------------------
    const conditionInitForFunds = useMemo(() => {
        return () => {
            function validFund(fund: FundWithDetailsEntity) {
                if (fund === undefined || fund._isDeployed === false) {
                    return false;
                }
                const validInvestUnit =
                    (fund.investUnit?.iudInvestUnit?.iuValues !== undefined && fund.investUnit.iudInvestUnit.iuValues.length > 0) ||
                    (fund.investUnit?.investUnitWithADAPrices?.iuValuesWithDetailsAndAmount !== undefined &&
                        fund.investUnit.investUnitWithADAPrices.iuValuesWithDetailsAndAmount.length > 0);
                if (!validInvestUnit) {
                    return false;
                }
                return true;
            }
            const result =
                mode === 'FundDetails'
                    ? isLoadedDetails === true && fund !== undefined && validFund(fund)
                    : isLoadedList === true && funds !== undefined && funds.length > 0 && funds.some(validFund);

            //----------------------------
            console.log(`[TokensStore] - Job: ${name} - conditionInit: ${result}`);
            //----------------------------
            return result;
        };
    }, [mode, isLoadedDetails, fund, isLoadedList, funds, name]);
    //--------------------------------------
    const { tokensStore, tokensFromStore, isTokensStoreReady, setIsTokensStoreReady, isTokensStoreLoading, setIsTokensStoreLoading, isAddingTokens } = useTokensStoreGeneral({
        ...props,
        name,
        swHandleCreateJob: false,
        swAddTimeToName: false,
        conditionInit: conditionInitForFunds,
        dependenciesInit: [isLoadedList, funds, isLoadedDetails, fund],
    });
    //--------------------------------------k
    useEffect(() => {
        setFund(props.fund);
    }, [props.fund]);
    //--------------------------------------
    useEffect(() => {
        setFunds([...(props.funds ?? [])]);
    }, [props.funds]);
    //--------------------------------------
    useEffect(() => {
        const initStore2 = async () => {
            //--------------------------------------
            console.log(`[TokensStore] - Job: ${name} - initStore2`);
            //--------------------------------------
            tokensStore.createJobTokensToAddFromFunds({
                job: name,
                funds: funds!,
                followUp: initPriceUpdater === true ? true : followUp,
                addTokenFT,
                addSubTokensFT,
                swAddPrice,
                swAddMetadata,
                keepAlive,
            });
            //--------------------------------------
        };
        if (isTokensStoreLoading === true && mode === 'FundList') {
            initStore2();
        }
    }, [isTokensStoreLoading]);
    //--------------------------------------
    useEffect(() => {
        const initStore2 = async () => {
            //--------------------------------------
            console.log(`[TokensStore] - Job: ${name} - initStore2`);
            //--------------------------------------
            tokensStore.createJobTokensToAddFromFund({
                job: name,
                fund: fund!,
                followUp: initPriceUpdater === true ? true : followUp,
                addTokenFT,
                addSubTokensFT,
                swAddPrice,
                swAddMetadata,
                keepAlive,
            });
            //--------------------------------------
        };
        if (isTokensStoreLoading === true && mode === 'FundDetails') {
            initStore2();
        }
    }, [isTokensStoreLoading]);
    //--------------------------------------
    return { tokensStore, isTokensStoreReady, isAddingTokens, isTokensStoreLoading, tokensFromStore, fund, setFund, funds, setFunds };
    //--------------------------------------
};
